
































import { api_post, api_get, http_withoutcookie } from '@/utils/http'
import { msgTip } from '@/utils/urlUtils'
import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import Modal from './../../enroll/Modal.vue'
import ImgCode from './../../enroll/ImgCode.vue'
import { AButton } from './../../../components'

@Component({
  components: { Modal, ImgCode, AButton }
})
export default class TestJeyoo extends Vue {
  public visible = false
  public request_error = ''
  public code = ''
  public imgCodeSrc = ''
  public code_error = ''
  @Prop() public show!: boolean
  @Watch('show')
  onShowChange(val) {
    this.visible = val
  }
  @Watch('visible')
  onVisibleChange(val) {
    if (val) {
      this.getImageCode()
    }
  }
  @Emit()
  onClose(val) {
    return val
  }
  @Emit()
  logSuccess() {}

  public closeModal() {
    this.visible = false
    this.onClose(this.visible)
  }
  public mounted() {
    // this.getImageCode()
  }
  /**
   * getFocus
   */
  public getFocus() {}
  /**
   * removeFocus
   */
  public removeFocus() {}
  /**
   * getImageCode
   */
  public async getImageCode() {
    let rdata = await http_withoutcookie('/search/api/auth/account/login', {
      domain: 'jyeoo'
    })
    if (rdata.success) {
      this.imgCodeSrc = rdata.data.captcha_image_src + '?s=' + Math.random()
    } else {
      this.request_error = rdata.request_error || ''
    }
  }
  public async clickLogin() {
    let rdata = await http_withoutcookie('/search/api/auth/account/login', {
      domain: 'jyeoo',
      captcha: this.code
    })
    if (rdata.success) {
      this.logSuccess()
      this.closeModal()
    } else {
      this.code_error = rdata.code_error || rdata.ode_error || ''
    }
  }
}
